<app-modal [modalId]="modalId" class="seller-disclosure-modal">
  <header class="modal__header" role="alert">
    <h1
    class="modal__title fw-normal pt-sm-5 pt-3"
    [attr.id]="modalId + '-title'"
    tabindex="-1"
    aria-labelledby="seller-disclosure-modal-header"
    role="alert"
    >
    <span class="visually-hidden" id="seller-disclosure-modal-header">{{translations.sellerDisclosureModal}}</span>
    <span aria-hidden="true">
      <strong> {{ translations.sellerDisclosureHeader }} </strong>
    </span>
    </h1>
  </header>
  <div class="modal__content mb-3">
    <div class="modal__body">
      <p class="seller-disclosure-body-1">{{translations.sellerDisclosureBody1}}</p>
      <p class="seller-disclosure-body-2">{{translations.sellerDisclosureBody2}}</p>
      <p class="seller-disclosure-body-3">{{translations.sellerDisclosureBody3}}</p>
      <p class="seller-disclosure-body-4" #sellerDisclosureBody4></p>
    </div>
    <button
      id="bm-close-button"
      class="btn btn-primary close-button"
      type="button"
      [attr.aria-label]="translations.modalClose"
      (click)="close()"
      data-track-elem="button"
      data-track-name="Close"
      data-track-trigger="close"
      data-test-id="app-seller-disclosure-modal-e-close-button"
      >
      <span>{{ translations.modalClose }}</span>
    </button>
  </div>
    <div class="modal-close-container fixed-top">
    <button
      id="bm_close_x_button"
      class="modal__close btn-link p-0"
      [attr.aria-label]="translations.modalClose"
      (click)="close()"
      data-track-elem="icon"
      data-track-name="Close"
      data-track-trigger="close"
      data-test-id="app-seller-disclosure-modal-e-x-close-button"
    >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
  </div>
</app-modal>
